import { render, staticRenderFns } from "./modal-takeover.vue?vue&type=template&id=4b51dfea"
import script from "./modal-takeover.vue?vue&type=script&lang=js"
export * from "./modal-takeover.vue?vue&type=script&lang=js"
import style0 from "./modal-takeover.vue?vue&type=style&index=0&id=4b51dfea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports